Namespace 'Common.Dashboard.Filters'

Common.Dashboard.Filters.FixedStringFilterMixin =
  attributeCode: ->
    @filter.getCode()

  openFixedStringFilterModal: ->
    @fixedStringFilterView?.remove()
    @fixedStringFilterView = new CustomerVisualMode.Filters.SingleFilters.FixedStringFilterView(
      values: @filter.getAttribute().get('tags')
      placeholder: I18n.t 'common.session.filters.fixed_string.modal.placeholder'
      title: @modalTitle()
      subtitle: @modalSubtitle()
      selectedOptions: @filter.getValues().map (value) -> value.name
    ).render()
    @listenTo(@fixedStringFilterView, 'filters:multiplevalues:apply', => @triggerFilterApplied())

  triggerFilterApplied: ->
    @trigger('filter:apply', @fixedStringFilterView.getSelectedValues())
